
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.327 1.94a1.5 1.5 0 012.121 0l3 3a1.5 1.5 0 010 2.12l-13.5 13.5a1.5 1.5 0 01-.585.363l-4.5 1.5a1.5 1.5 0 01-1.899-1.897l1.5-4.5a1.5 1.5 0 01.363-.587l13.5-13.5zM18.387 3l3 3-13.5 13.5-4.5 1.5 1.5-4.5L18.388 3z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.607 9.53l-3.75-3.75 1.062-1.061 3.75 3.75-1.06 1.062h-.002zM4.887 15v.75a.75.75 0 00.75.75h.75v.75a.75.75 0 00.75.75h.75v.75a.75.75 0 00.75.75h.75v-2.25a.75.75 0 00-.75-.75h-.75v-.75a.75.75 0 00-.75-.75h-2.25z"}})])
          )
        }
      }
    